import { render, staticRenderFns } from "./EmissionsByScope.vue?vue&type=template&id=2309ba1b"
import script from "./EmissionsByScope.vue?vue&type=script&lang=js"
export * from "./EmissionsByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports